import { render, staticRenderFns } from "./ConnectForm.vue?vue&type=template&id=4780d76c&"
import script from "./ConnectForm.vue?vue&type=script&lang=js&"
export * from "./ConnectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports